// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum EventoEnum {
  Bascula = 1,
  InicioExtendido = 2,
  FinExtendido = 3,
  LlegadaObra = 4,
  LlegadaPlanta = 5,
  RechazarCarga = 6
}
